























import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class UiLabel extends mixins(PlanLimitsMixin) {
  @Prop({ default: true })
  textBold: boolean;

  @Prop({ default: {} })
  customStyle!: object;

  @Prop()
  text: string;

  @Prop()
  helpTooltip: string;
}
